import React from "react";
import "../styles/pricing.css";
import { Link } from "react-router-dom";

const Pricing = () => {
  return (
    <div className="pricing-page">
      <section className="pricing-intro">
        <h1>Pricing Plans</h1>
        <p className="notice">
          <strong>Note:</strong> All new customers are required to subscribe for a minimum of three months. After this period, you can renew monthly, quarterly, or annually, per our{" "}
          <Link to="/terms">Terms of Service</Link>.
        </p>
        <p className="subtitle">Choose the plan that best fits your needs.</p>
      </section>

      {/* Pricing Cards */}
      <div className="pricing-cards">
        <div className="card basic">
          <h2>Basic</h2>
          <p className="price">₦7,500 <span>/vehicle/month</span></p>
          <ul>
            <li>✅ Free GPS Tracker</li>
            <li>✅ Real-Time GPS Tracking</li>
            <li>✅ 14-Day Trip History</li>
            <li>✅ 24/7 Support</li>
          </ul>
          <Link to="/register" className="cta">Get Started</Link>
        </div>

        <div className="card standard">
          <h2>Standard</h2>
          <p className="price">₦12,000 <span>/vehicle/month</span></p>
          <ul>
            <li>✅ Free GPS Tracker</li>
            <li>✅ Real-Time GPS Tracking</li>
            <li>✅ Basic Alerts & Notifications</li>
            <li>✅ Geofencing</li>
            <li>✅ 30-Day Trip History</li>
            <li>✅ Fuel Monitoring</li>
            <li>✅ 24/7 Support</li>
          </ul>
          <Link to="/register" className="cta">Get Started</Link>
        </div>

        <div className="card premium">
          <h2>Premium</h2>
          <p className="price">₦18,000 <span>/vehicle/month</span></p>
          <ul>
            <li>✅ Advanced GPS Tracker</li>
            <li>✅ Real-Time GPS Tracking</li>
            <li>✅ Fuel Monitoring</li>
            <li>✅ Advanced Geofencing</li>
            <li>✅ Critical Alerts & Notifications</li>
            <li>✅ 3-Month Trip Playback</li>
            <li>✅ AI Analytics & Reports</li>
            <li>✅ Customized Service</li>
            <li>✅ Priority 24/7 Support</li>
          </ul>
          <Link to="/register" className="cta">Get Started</Link>
        </div>
      </div>

      {/* Additional Fees */}
      <section className="fees-section">
        <h3>🔧 Installation Fees</h3>
        <ul>
          <li>Motorcycles & Tricycles – ₦3,000</li>
          <li>Cars & Buses – ₦7,000</li>
          <li>Trucks – ₦10,000</li>
        </ul>
        <p className="note">Includes professional installation by certified technicians, tailored to your vehicle type.</p>

        <h4>Non-Compliance Fee: ₦20,000 per vehicle</h4>
        <p>Charged if the GPS tracker is not returned or is damaged at the end of your subscription.</p>
      </section>

      {/* Referral */}
      <section className="referral">
        <h3>🏆 Referral Program</h3>
        <p>Refer your friends and earn <strong>₦2,000</strong> for every successful signup.</p>
        <Link to="/contact" className="cta-light">Learn More</Link>
      </section>

      {/* FAQs */}
      <section className="faqs">
        <h3>📚 Frequently Asked Questions</h3>
        <div className="faq">
          <strong>Why ₦250/day?</strong>
          <p>This is the breakdown of our Basic Plan (₦7,500/month) to show how affordable tracking is—less than fuel or maintenance!</p>
        </div>
        <div className="faq">
          <strong>Are trackers really free?</strong>
          <p>Yes! You get one at no cost, but it remains our property. Unreturned devices cost ₦30,000.</p>
        </div>
        <div className="faq">
          <strong>Can I cancel anytime?</strong>
          <p>After 3-month commitment, cancel anytime with 7–14 days' notice and we’ll schedule free uninstallation.</p>
        </div>
        <div className="faq">
          <strong>Is my data safe?</strong>
          <p>Yes! We are NDPR-compliant and use secure, encrypted storage. <Link to="/privacy">Read our Privacy Policy</Link>.</p>
        </div>
        <div className="faq">
          <strong>Payment methods?</strong>
          <p>We accept Paystack, Flutterwave, USSD, and bank transfers. Need a plan? <Link to="/contact">Contact us</Link>.</p>
        </div>
      </section>

      {/* Call to Action */}
      <section className="cta-footer">
        <h2>🚗 Ready to Track Your Fleet?</h2>
        <p>Get started for as low as ₦250/day. Free tracker included!</p>
        <Link to="/register" className="cta">Sign Up Now</Link>
        <p className="support-note">📱 Questions? <a href="https://wa.me/2349027161192" target="_blank" rel="noopener noreferrer">Chat on WhatsApp</a></p>
      </section>

      <footer className="footer">
        <p>© 2025 TrackSmart Solutions</p>
        <p><Link to="/privacy">Privacy Policy</Link> | <Link to="/terms">Terms</Link> | <Link to="/faq">FAQs</Link> | <Link to="/contact">Contact</Link></p>
      </footer>
    </div>
  );
};

export default Pricing;
